import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	switchSitesOrAppsTooltip: {
		id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
		defaultMessage: 'Switch sites or apps',
		description:
			'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.',
	},
	tenantlessTopOrgSwitcherText: {
		id: 'fabric.atlassianSwitcher.tenantlessTopOrgSwitcherText',
		defaultMessage: 'Select organisation',
		description: 'The text of the organisation switcher item when no organisation is selected',
	},
	switcherModalLabel: {
		id: 'fabric.atlassianSwitcher.modalLabel',
		defaultMessage: 'Atlassian App Switcher',
		description: 'The label of the switcher modal',
	},
	joinStatusText: {
		id: 'fabric.atlassianSwitcher.joinStatusText',
		defaultMessage: 'Join',
		description: 'The text displayed alongside a product to indicate the product is joinable.',
	},
	instantAccessStatusText: {
		id: 'fabric.atlassianSwitcher.instantAccessStatusText',
		defaultMessage: 'Instant access',
		description: 'The text displayed alongside a product to indicate the product is joinable.',
	},
	joinTeamStatusText: {
		id: 'fabric.atlassianSwitcher.joinTeamStatusText',
		defaultMessage: 'Join team',
		description: 'The text displayed alongside a product to indicate the product is joinable.',
	},
	jpdDescriptionText: {
		id: 'fabric.atlassianSwitcher.jpdDescriptionText',
		defaultMessage: 'Prioritize and plan new ideas',
		description: 'The description displayed for Jira Product Discovery.',
	},
	confluenceDescriptionText: {
		id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
		defaultMessage: 'Document and collaborate',
		description: 'The description displayed for Confluence.',
	},
	jiraDescriptionText: {
		id: 'fabric.atlassianSwitcher.jiraDescriptionText',
		defaultMessage: 'Plan and track project delivery',
		description: 'The description displayed for Jira.',
	},
	jsmDescriptionText: {
		id: 'fabric.atlassianSwitcher.jsmDescriptionText',
		defaultMessage: 'Automate and deliver IT support',
		description: 'The description displayed for Jira Service Management.',
	},
	requestSentStatusText: {
		id: 'fabric.atlassianSwitcher.requestSentStatusText',
		defaultMessage: 'Request sent',
		description:
			'The text displayed alongside a product to indicate the user has requested access to the product.',
	},
	requestAccessPendingRequestFlagTitle: {
		id: 'fabric.atlassianSwitcher.successFlag.title',
		defaultMessage: 'Access request sent to Admin',
		description:
			'Title shown when user has requested access to a product but the request is pending.',
	},
	requestAccessPendingRequestFlagDescription: {
		id: 'fabric.atlassianSwitcher.successFlag.description',
		defaultMessage: "You'll get an email once it's approved",
		description:
			'Description shown when user has requested access to a product but the request is pending',
	},
	requestAccessPendingRequestFlagErrorTitle: {
		id: 'fabric.atlassianSwitcher.errorFlag.title',
		defaultMessage: `We couldn't add you to {product}`,
		description:
			'Title shown when user has requested access to a product but the request has failed.',
	},
	requestAccessPendingRequestFlagErrorDescription: {
		id: 'fabric.atlassianSwitcher.errorFlag.description',
		defaultMessage:
			"Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
		description:
			'Description shown when user has requested access to a product but the request is pending',
	},
	reorderItemErrorFlagTitle: {
		id: 'fabric.atlassianSwitcher.reorderItemErrorFlagTitle',
		defaultMessage: 'Something went wrong',
		description: 'The title of the error flag for reordering items in the switcher',
	},
	reorderItemErrorFlagDescription: {
		id: 'fabric.atlassianSwitcher.reorderItemErrorFlagDescription',
		defaultMessage: 'Please refresh the page or try again later.',
		description: 'The description of the error flag for reordering items in the switcher',
	},
	reorderItemErrorFlagAction: {
		id: 'fabric.atlassianSwitcher.reorderItemErrorFlagAction',
		defaultMessage: 'Got it',
		description: 'The action of the error flag for reordering items in the switcher',
	},
	jiraDescriptionTextGalaxia: {
		id: 'fabric.atlassianSwitcher.jiraDescriptionText-galaxia',
		defaultMessage: 'Plan and track project delivery',
		description: 'The description displayed for Jira.',
	},
	otherSectionOfOrgSwitcher: {
		id: 'fabric.atlassianSwitcher.otherSectionOfOrgSwitcher',
		defaultMessage: 'Other',
		description: 'Text displayed as the title of the other section of the org switcher.',
	},
});
export default messages;
